import Button, { ButtonProps } from "@material-ui/core/Button"
import makeStyles from "@material-ui/styles/makeStyles";

import clsx from 'clsx'
import { useI18n } from '../hooks/i18n-hooks';

interface AcceptCancelButtonsProps {
	whiteDisabled?: boolean;
	whiteOnClick?(): any;
	whiteText?: string;
	whiteProps?: ButtonProps;
	greenDisabled?: boolean;
	greenOnClick?(): any;
	greenText: string;
	greenProps?: ButtonProps;
}
const AcceptCancelButtons: React.FC<AcceptCancelButtonsProps> = ({ whiteDisabled, whiteOnClick, whiteText, whiteProps, greenDisabled, greenOnClick, greenText, greenProps }) => {

	const classes = useStyles();

	const cancel = useI18n(i => i.pd.cancel);

	return (
		<>
			<Button
				variant="outlined"
				color="primary"
				disabled={whiteDisabled}
				onClick={whiteOnClick}
				className={clsx(classes.button)}
				{...whiteProps}
			>{whiteText || cancel}</Button>
			<Button
				variant="contained"
				color="primary"
				disabled={greenDisabled}
				onClick={greenOnClick}
				className={clsx(classes.button, classes.greenButton)}
				{...greenProps}
			>{greenText}</Button>
		</>

	)
}

export default AcceptCancelButtons;


//styling
const useStyles = makeStyles({
	button: {
		fontFamily: "Assistant-Bold",
		fontSize: '1rem',
		textTransform: "none",
	},
	greenButton: {
		marginLeft: '12px',
	},
});